import { Text } from "design_system";
import Link from "next/link";
import React from "react";
import Markdown from "react-markdown";
import rehypeRaw from "rehype-raw";

export default function PricingFeatures({
  featuresList,
}: {
  featuresList: string[];
}) {
  return (
    <ul className="flex flex-col">
      {featuresList.map((feature, index) => (
        <React.Fragment key={`feature-${index}`}>
          <li className="flex w-full items-center gap-x-3 py-4 first:pt-0 last:pb-0">
            <i className="text-xl text-positive-fg-base icon-check" />
            <div className="min-h-14 flex flex-col justify-center">
              <Markdown
                rehypePlugins={[rehypeRaw]}
                components={{
                  small: ({ children }) => (
                    <Text
                      as="small"
                      size="x-sm"
                      weight="regular"
                      theme="muted"
                      className="!leading-[1.2]"
                    >
                      {children}
                    </Text>
                  ),
                  p: ({ children }) => (
                    <Text
                      as="p"
                      size="sm"
                      weight="regular"
                      className="!leading-[1.2] not-only:first:mb-1"
                    >
                      {children}
                    </Text>
                  ),
                  u: ({ children }) => (
                    <Text
                      as="span"
                      size="x-sm"
                      weight="regular"
                      theme="muted"
                      className="underline underline-offset-3 !leading-[1.2] !m-0"
                    >
                      {children}
                    </Text>
                  ),
                  a: ({ children, href }) => (
                    <Link href={href ?? ""} target="_blank">
                      <Text
                        as="span"
                        size="sm"
                        weight="regular"
                        className="underline underline-offset-2 !leading-[1.2]"
                      >
                        {children}
                      </Text>
                    </Link>
                  ),
                }}
              >
                {feature}
              </Markdown>
            </div>
          </li>
          {index < featuresList.length - 1 && (
            <div
              className="w-full h-[1px] bg-border-base"
              style={{
                maskImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='32' height='1'><rect x='0' y='0' width='16' height='1' fill='black'/></svg>")`,
                maskRepeat: "repeat-x",
                WebkitMaskImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='32' height='1'><rect x='0' y='0' width='16' height='1' fill='black'/></svg>")`,
                WebkitMaskRepeat: "repeat-x",
              }}
            />
          )}
        </React.Fragment>
      ))}
    </ul>
  );
}
